// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2QHqa","content":"styles_content__1VGGi","selectAll":"styles_selectAll__3hZdJ"};